module.exports = __webpack_public_path__ + "static/img/Aigif.5f2c17dc.gif";